import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { ResponseGQL } from './types';

const getSwagUrl = (contextPath: string): string => `${contextPath}/jsw2/graphql`;

const softwareReportVelocityEstimationConfigOperationName =
	'SoftwareReportVelocityEstimationConfig';

const getQuery = (
	boardId: number,
): string => `query ${softwareReportVelocityEstimationConfigOperationName} {
    agile { board(id:${boardId}) {
        estimation {
            current {
                customFieldId
                name
            }
        }
    }}
}`;

const fetchEstimationConfig = (
	contextPath: string,
	rapidViewId: number,
): ObservableType<ResponseGQL> =>
	fetchJson$(getSwagUrl(contextPath), {
		method: 'POST',
		body: JSON.stringify({
			operationName: softwareReportVelocityEstimationConfigOperationName,
			query: getQuery(rapidViewId),
		}),
	});

export default fetchEstimationConfig;
